import React from 'react';
import OtpInput from 'react-otp-input';
import { useState } from 'react';
import { Alert } from '../../../services/notiflix.service';
import { verifyTwoFA, login } from '../../../actions/auth';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthCommonButton from './AuthCommonButton';
import AuthHeaderTextComponent from './AuthHeaderTextComponent';
const TwoStepVerificationOtp = ({ authUser }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState(0);
  const [isLoader, setLoader] = useState(false);
  const onVerifyOtp = async () => {
    if (!otp || otp?.length < 6) {
      Alert.error('Please enter 6 digit code');
      return false;
    }
    setLoader(true);
    try {
      const _verifyOtpData = {
        code: otp,
        token: authUser.token,
      };

      let resp = await Promise.resolve(dispatch(verifyTwoFA(_verifyOtpData)));

      if (resp.status === 'failure') {
        setLoader(false);
        Alert.error(resp.message);
        return false;
      }

      setLoader(false);
      await Promise.resolve(dispatch(login(authUser)));

      navigate('/profile');
    } catch (error) {
      setLoader(false);
      Alert.error(error.message);
    }
  };
  return (
    <>
      <div className="w-full md:w-96 bg-white dark:bg-slate-800  dark:text-slate-200 px-6 py-10 rounded-md m-6">
        <AuthHeaderTextComponent
          title={'Authenticate your account'}
          desc={
            'Please confirm your identity with your 2-factor authentication code.'
          }
        />
        <div className="flex items-center justify-center w-full py-6">
          <OtpInput
            value={otp}
            containerStyle="w-full justify-center"
            inputStyle="min-w-[44px] h-11 p-3"
            onChange={(_otp) => setOtp(_otp)}
            numInputs={6}
            renderSeparator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
          />
        </div>
        <div className="mt-4">
          <AuthCommonButton
            isLoader={isLoader}
            Title={'Verify'}
            onClick={onVerifyOtp}
          />
        </div>
      </div>
    </>
  );
};

export default TwoStepVerificationOtp;
